var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009041"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1190",
    d: "M13.4591 4.08171C12.8368 3.93627 12.1885 3.85938 11.5222 3.85938C6.81552 3.85938 3 7.69695 3 12.4308C3 17.1647 6.81552 21.0023 11.5222 21.0023C16.2289 21.0023 20.0444 17.1647 20.0444 12.4308C20.0444 12.0344 20.0177 11.6442 19.9658 11.262",
    stroke: "#EC187B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9132 3.53256C18.2522 3.19157 18.712 3 19.1915 3C19.671 3 20.1308 3.19157 20.4698 3.53256C20.8089 3.87356 20.9993 4.33604 20.9993 4.81828C20.9993 5.30052 20.8089 5.76301 20.4698 6.104L12.3737 14.2469L8.96484 15.104L9.81706 11.6755L17.9132 3.53256Z",
    stroke: "#EC187B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4818c17acc09a25ea55b142ec5c31294.svg";
export { ForwardRef as ReactComponent };